module.exports = __webpack_public_path__ + "img/11.2fc90ae4.png";